import * as React from "react";
import { styled, Typography } from "@mui/material";
import { Link, To } from "react-router";
import Cover from "../../Misc/Cover";

export type GenreCardProps = {
  to: To;
  cover: string;
  title: string;
  subtitle: string;
};

const GenreCard: React.FC<GenreCardProps> = (props) => {
  return (
    <StyledLink to={props.to}>
      <Cover img={{ src: props.cover, alt: props.title }} />
      {props.subtitle && (
        <Typography component="span" variant="body1">
          {props.subtitle}
        </Typography>
      )}
      <Typography component="h3" variant="subtitle1" fontWeight={700} sx={{ mt: "auto" }}>
        {props.title}
      </Typography>
    </StyledLink>
  );
};

export default GenreCard;

const StyledLink = styled(Link)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  color: theme.palette.common.white,
  width: 184,
  height: 120,
  borderRadius: 8,
  overflow: "hidden",
  boxShadow: theme.shadows[4],
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(2.5)}`,
  "&:hover": {
    "&:after": {
      opacity: 0.6,
    },
  },
  "span, h3": {
    position: "relative",
    zIndex: 1,
  },

  "&:after": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    content: '""',
    background: "linear-gradient(0deg, rgba(0, 0, 0, 0.64), rgba(0, 0, 0, 0.64))",
    transition: "opacity .3s",
    opacity: 0,
    pointerEvents: "none",
  },
}));
